import { SearchableProfile } from 'types/notification.types';
import { Collaborator } from 'types/collaborator.types';
import { getAvatarImage } from 'app/utils/utils';
import { SuggestedCollaborator } from './SuggestedCollaboratorsList';
import { CollaboratorChip } from '../types';

export const isSameCollaborator = (
  { collaborator, inviteeEmail }: SuggestedCollaborator,
  {
    collaborator: collaborator2,
    inviteeEmail: inviteeEmail2,
  }: SuggestedCollaborator
) => {
  const sameSubjects =
    collaborator &&
    collaborator2 &&
    collaborator?.subject === collaborator2?.subject;

  const sameEmails =
    inviteeEmail && inviteeEmail2 && inviteeEmail === inviteeEmail2;

  return sameSubjects || sameEmails;
};

export const compareChipWithCollaborator = (
  { displayName, subject }: CollaboratorChip,
  { collaborator, inviteeEmail }: SuggestedCollaborator
) => {
  if (subject && collaborator?.subject && subject === collaborator?.subject) {
    return true;
  }

  if (!subject && !collaborator?.subject && displayName === inviteeEmail) {
    return true;
  }
  return false;
};

export const getChip = ({
  collaborator,
  inviteeEmail,
  inviteType,
}: SuggestedCollaborator): CollaboratorChip | null => {
  if (inviteeEmail) {
    return {
      displayName: inviteeEmail,
      inviteType,
    };
  }

  if (collaborator) {
    return {
      ...collaborator,
      imageSrc: getAvatarImage(collaborator?.profileImages),
      inviteType,
    };
  }
  return null;
};

export const getMessage = (collaborator?: Collaborator) => {
  return !collaborator
    ? ''
    : collaborator.status === 'PENDING'
    ? 'Invite pending'
    : 'Already a collaborator on this Song';
};

export const profileToSuggestedCollaborator = (
  collaborator: SearchableProfile,
  songCollaborators?: Collaborator[],
  chips?: CollaboratorChip[]
): SuggestedCollaborator => {
  const existingCollaborator = songCollaborators?.find((collab) => {
    return collab.profileCard?.subject === collaborator.subject;
  });
  return {
    collaborator,
    selected:
      !!existingCollaborator ||
      chips?.some((chip) =>
        compareChipWithCollaborator(chip, {
          collaborator,
          inviteType: 'Suggestions',
        })
      ),
    disabled: !!existingCollaborator,
    message: getMessage(existingCollaborator),
    inviteType: 'Suggestions',
  };
};
